import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeId } from '../challenge/useChallengeId'

export const USER_BADGES_QUERY_KEY = (userID: string, challengeID: string) =>
  ['badges', 'user', userID, challengeID] as const

export function useUserBadges(userID: string, challengeIdOverride?: string) {
  const activeChallengeId = useChallengeId()
  const challengeId = challengeIdOverride || activeChallengeId

  return useQuery({
    queryKey: USER_BADGES_QUERY_KEY(userID, challengeId),
    queryFn: () => dataSource.getUserBadges(userID, challengeId),
    enabled: !!userID && !!challengeId,
    staleTime: 0,
    gcTime: 0,
  })
}
